import React, { useCallback } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { CountryFlag } from "@wf/components";
import { convertCountryCode } from "../../../../../helpers";

import styles from "./LanguageItem.module.scss";

interface Language {
  name: string;
  displayName: string;
}

interface LanguageItemProps {
  language: Language;
  onClick: (name: string) => void;
}

const LanguageItem: React.FC<LanguageItemProps> = ({ language, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(language.name);
  }, [onClick, language]);

  return (
    <li onClick={handleClick} className={cx(styles.language)}>
      <CountryFlag code={convertCountryCode(language.name)} />
      <span className={styles.name}>{language.displayName}</span>
    </li>
  );
};

LanguageItem.propTypes = {
  language: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired
};

export default Object.assign(React.memo(LanguageItem), { displayName: "LanguageItem" });
